
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(82076|98893)$/.test(chunkId);
},
rootOutputDir: "",

    };
}
